/* eslint-disable react/jsx-no-literals -- Allow hard-coded translations for now */
'use client'

import { type JSX } from 'react'

import { IconDescription } from '@redteclab/icons'

import { ProductPriceExplainerSection } from '../ProductPriceExplainerSection'

const SECTION_IDS = {
  PRICE_REDUCTION_BASIS: 'price-explainer-reduction-basis',
  PRICE_REFERENCE_TERMS: 'price-explainer-reference-terms',
}

export const ProductPriceExplainerContentAt = (): JSX.Element => {
  return (
    <div className="flex flex-col gap-6">
      <ProductPriceExplainerSection
        headingIcon={<IconDescription />}
        headingId={SECTION_IDS.PRICE_REFERENCE_TERMS}
        headingText="Wofür steht VK, Originalpreis oder Preis zuvor?"
      >
        <p>
          Apothekenabgabepreis basierend auf dem aktuellen Warenverzeichnis
          (inkl. Umsatzsteuer) bzw. Verbindlicher Verkaufspreis gemäß der
          deutschen ABDA-Datenbank (Stand: 01.05.2026) inkl. österreichischer
          Umsatzsteuer. Preisänderungen und Irrtümer vorbehalten. Bei Angabe des
          Originalpreises handelt es sich um den vorher gültigen Verkaufspreis
          des jeweiligen Händlers. Die Ersparnis ist ggf. zeitlich begrenzt.
        </p>
        <p>
          Die Angabe „Preis zuvor“ ist der niedrigste Gesamtpreis, den der
          jeweilige Anbieter des Produkts (wir oder der Marktplatzhändler)
          innerhalb der letzten 30 Tage vor der Anwendung der Preisermäßigung
          verlangt hat.
        </p>
      </ProductPriceExplainerSection>

      <ProductPriceExplainerSection
        headingIcon={<IconDescription />}
        headingId={SECTION_IDS.PRICE_REDUCTION_BASIS}
        headingText="Worauf bezieht sich die Ersparnis?"
      >
        <p>
          Ersparnis-Angabe im Vergleich zum Apothekenabgabepreis basierend auf
          dem aktuellen Warenverzeichnis (inkl. Umsatzsteuer) bzw. im Vergleich
          zum verbindlichen Verkaufspreis gemäß der deutschen ABDA-Datenbank
          (Stand: 01.05.2026) inkl. österreichischer Umsatzsteuer. Nur bei nicht
          verschreibungspflichtigen Medikamenten und Produkten (ausgenommen
          preisgebundene Bücher).
        </p>
        <p>
          Die angegebene Preisreduzierung bezieht sich auf den „Preis zuvor“,
          also den niedrigsten Gesamtpreis der letzten 30 Tage.
        </p>
      </ProductPriceExplainerSection>
    </div>
  )
}
